import { useEffect } from 'react'
import { getSocket } from './socketManager'

interface CardMethodSelectedData {
  storeId?: string | number
  kioskId?: string | number
  storeLabel?: string
  timestamp?: string
  [key: string]: unknown
}

export const useCardMethodSelectedNotifications = (
  onCardMethodSelected?: (data: CardMethodSelectedData) => void,
) => {
  useEffect(() => {
    const socket = getSocket()

    const handler = (data: CardMethodSelectedData) => {
      if (onCardMethodSelected) onCardMethodSelected(data)
    }

    socket.on('card-method-selected', handler)

    return () => {
      socket.off('card-method-selected', handler)
    }
  }, [onCardMethodSelected])
}
